import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useState } from 'react';
import { StandardButton } from '@eika/button';
import { Loader } from '@eika/loader';
import restClient from '../../restClient';
import ErrorMessage from '../error-message';
import SectionSummary from './section-summary';
const ProcessSummary = _ref => {
  let {
    summarySection,
    buttonAction,
    submitButtonText
  } = _ref;
  const [summary, setSummary] = useState();
  const [error, setError] = useState(null);
  useEffect(() => {
    restClient.processSummary().then(setSummary).catch(reason => setError(reason));
  }, [summarySection]);
  if (error) return /*#__PURE__*/React.createElement(ErrorMessage, {
    text: "Vi kunne ikke lagre svarene dine. Vennligst pr\xF8v igjen senere eller kontakt banken dersom problemene vedvarer"
  });
  if (!summary) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionSummary, {
    sections: summary.sectionSummary
  }), /*#__PURE__*/React.createElement(StandardButton, {
    className: "progress-next-button",
    onClick: buttonAction
  }, submitButtonText));
};
export default ProcessSummary;